$(document).ready(function () {
    $("body").on('change', "[name$='.gouvernorat']", function () {
        var grouvernoratID = $(this).val();
        var actionURL = $(this).parents(".adresse").data('municipalite-get-url').replace('\{id\}', grouvernoratID);
        var muncipalitesListChoix = $(this).parents('.form-group').next().find('select');
        $.ajax({
            method: "get",
            url: actionURL,
            success: function (data) {
                muncipalitesListChoix.find('option').remove();
                for (const property in data) {
                    muncipalitesListChoix.append($('<option value="'+property+'">'+data[property]+'</option>'));
                }
            }
        })
    });
});